module.exports = __webpack_public_path__ + "front/img/c15.4e066a0d.png";